import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook, CreditCard } from "lucide-react";

const logoUrl = "https://customer-assets.emergentagent.com/job_luxury-facial-pro/artifacts/gjd36s6k_Gemini_Generated_Image_rqozrirqozrirqoz.png";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={logoUrl} 
                alt="LuxuryBeauty" 
                className="h-20 w-auto"
              />
            </Link>
            <p className="font-body text-lg text-[#A3A3A3] leading-relaxed max-w-md mb-6">
              The only salon/spa offering these services 
              in Georgetown & Mahaica. Services, esthetics courses, and skills training to help 
              you look your best or start your own business.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/luxurybeauty.ca"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 border border-[#262626] flex items-center justify-center text-[#A3A3A3] hover:border-[#C5A059] hover:text-[#C5A059] transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.facebook.com/luxury.beauty06"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-10 h-10 border border-[#262626] flex items-center justify-center text-[#A3A3A3] hover:border-[#C5A059] hover:text-[#C5A059] transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs font-semibold tracking-[0.3em] uppercase text-[#C5A059] mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-4">
              {[
                { name: "Home", path: "/" },
                { name: "Services", path: "/services" },
                { name: "Wedding", path: "/wedding" },
                { name: "Courses", path: "/courses" },
                { name: "Skills Academy", path: "/skills-academy" },
                { name: "Events", path: "/events" },
                { name: "Gift Cards", path: "/gift-cards" },
                { name: "Loyalty Card", path: "/loyalty" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="font-body text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-body text-xs font-semibold tracking-[0.3em] uppercase text-[#C5A059] mb-6">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="mailto:info@luxurybeauty.ca"
                data-testid="footer-email"
                className="flex items-center gap-3 font-body text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300"
              >
                <Mail size={16} className="text-[#C5A059]" />
                info@luxurybeauty.ca
              </a>
              <a
                href="tel:+5926471133"
                data-testid="footer-phone"
                className="flex items-center gap-3 font-body text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300"
              >
                <Phone size={16} className="text-[#C5A059]" />
                +592 647 1133
              </a>
              <div className="flex items-start gap-3 font-body text-[#A3A3A3]">
                <MapPin size={16} className="text-[#C5A059] mt-1 flex-shrink-0" />
                <span>Lot 18 Helena #1<br />Mahaica, East Coast Demerara<br />Guyana</span>
              </div>

              {/* MMG Payment */}
              <div className="flex items-start gap-3 font-body mt-2 pt-4 border-t border-[#262626]">
                <CreditCard size={16} className="text-[#C5A059] mt-1 flex-shrink-0" />
                <div>
                  <span className="text-[#C5A059] text-xs font-semibold tracking-wider uppercase block mb-1">We Accept MMG</span>
                  <span className="text-[#A3A3A3] text-sm">Merchant: <strong className="text-white">LB Beauty</strong></span>
                  <span className="text-[#A3A3A3] text-xs block mt-1">Send payment receipt to confirm.</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#262626] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-sm text-[#A3A3A3]">
            &copy; {new Date().getFullYear()} LuxuryBeauty.CA. All rights reserved.
          </p>
          <p className="font-body text-sm text-[#A3A3A3]">
            Luxury Beauty
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
